import K from "utilities/constants";
import {
  isPermissionPresent,
  removeUnderScore,
  toolTipRemoveUnderScore,
} from "utilities/generalUtility";
import { DefaultColumnOptions } from "../../../hooks/useDataGrid/options";
import { EditIconButton } from "../../../common/components/iconButton/editIconButton";

const actionColumnRenderer = (roles, editHandler) => (params) => (
  <>
    {isPermissionPresent(K.Permissions.EditJobBilling, roles) && (
      <EditIconButton onClick={() => editHandler(params.data)} />
    )}
  </>
);

const dependentColumnRenderer = (params) => {
  if (params.data.isDependentOn) {
    return params.data.isDependentOnSalary
      ? "Candidate Salary"
      : params.data.dependantOnJobBillingType.name;
  }
  return "false";
};

const tooltipDependentColumnRenderer = (params) => {
  if (params.data.isDependentOn) {
    return (
      <div className="client-list-tooltip">
        {params.data.isDependentOnSalary
          ? "Candidate Salary"
          : params.data.dependantOnJobBillingType.name}
      </div>
    );
  }
  return <div className="client-list-tooltip">false</div>;
};

const toolTipTypeRenderer = (params) =>
  toolTipRemoveUnderScore(params.value) === "Time Based"
    ? "After Certain Period "
    : toolTipRemoveUnderScore(params.value);

const typeRenderer = (params) =>
  removeUnderScore(params.value) === "Time Based"
    ? "After Certain Period "
    : removeUnderScore(params.value);

export const getColumns = (roles, editHandler) => [
  DefaultColumnOptions.Id,
  {
    headerName: "Name",
    field: "name",
    sortable: true,
    sort: "asc",
    tooltipField: "name",
    suppressMovable: true,
  },
  {
    headerName: "Type",
    field: "type",
    sortable: true,
    suppressMovable: true,
    tooltipField: "type",
    tooltipComponent: toolTipTypeRenderer,
    cellRenderer: typeRenderer,
  },
  {
    headerName: "Status",
    field: "isAssignable",
    sortable: true,
    tooltipField: "isAssignable",
  },
  {
    headerName: "Has MarkUp",
    field: "hasMarkup",
    sortable: true,
    tooltipField: "hasMarkup",
  },
  {
    headerName: "Required",
    field: "isRequired",
    sortable: true,
    tooltipField: "isRequired",
  },
  {
    headerName: "Dependent On",
    field: "isDependentOn",
    sortable: true,
    tooltipField: "isDependentOn",
    tooltipComponent: tooltipDependentColumnRenderer,
    cellRenderer: dependentColumnRenderer,
  },
  {
    ...DefaultColumnOptions.Actions,
    hide: !isPermissionPresent(K.Permissions.EditJobBilling, roles),
    cellRenderer: actionColumnRenderer(roles, editHandler),
  },
];
